import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import Image from '@jetshop/ui/Image';
import { theme } from '../Theme';
import { LinkEvaluator } from '../../utils/LinkEvaluator';
// import { SmallParagraph } from '../ui/text/SmallParagraph';
// import { Heading3 } from '../ui/text/Heading3';
import { useIntl } from '@jetshop/intl';
import { useQuery } from 'react-apollo';
import Products from './Products.gql';
// import { useBase64 } from '../../hooks/useBase64';
import { Paragraph } from '../ui/text/Paragraph';
import { PushPrice } from '../ui/StyledPrice';
// import { Checkbox } from '../ui/Checkbox';
import { QuickBuyButton } from '../Layout/QuickBuy/QuickBuyButton';

const UpsellListWrapper = styled('div')`
  width: 100%;

  .heading-3 {
    margin: 10px 0;
  }
`;

const UpsellListItemsWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  > * {
    width: fit-content;
    margin-bottom: 13px;
  }

  .upsell-list-item-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 13px;
    margin-top: 16px;
  }

  .upsell-list-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    .image-and-information-combo-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }
    .item-image-wrapper {
      background: ${theme.colors.lightgrey};
      width: 80px;
      height: 80px;

      img {
        mix-blend-mode: darken;
      }
    }
    .internal-link,
    link {
      width: 80px;
    }

    .small-paragraph {
      margin-top: 6px;
    }
    .push-style.price {
      font-size: 23px;
    }
    .quick-buy-button {
      border-radius: 3px;
      margin-top: 2rem;
    }
  }
`;

export const UpsellList = ({
  articleNumbers,
  title,
  setSelectedProducts,
  selectedProducts
}) => {
  const { data } = useQuery(Products, {
    variables: {
      articles: articleNumbers
    },
    errorPolicy: 'ignore'
  });

  const translate = useIntl();
  const titleText = translate(title);

  return (
    <UpsellListWrapper className="upsell-list-wrapper">
      {/* <Heading3 text={titleText} /> */}
      <UpsellListItemsWrapper>
        {data?.products?.map((product, index) => {
          return (
            <div
              key={'upsell-list-' + index}
              className="upsell-list-item-wrapper"
            >
              <UpsellListItem
                product={product}
                setSelectedProducts={setSelectedProducts}
                selectedProducts={selectedProducts}
              />
            </div>
          );
        })}
      </UpsellListItemsWrapper>
    </UpsellListWrapper>
  );
};

const UpsellListItem = ({ product, setSelectedProducts, selectedProducts }) => {
  const imageAspect = '1:1';
  const imageSizes = [1 / 2, 1 / 2, 1 / 3, 1 / 4];
  const itemHeader =
    product?.customFields?.find(({ key }) => key === 'brand')?.stringValue ??
    '';

  // const handleCheckbox = value => {
  //   if (value) {
  //     setSelectedProducts([...selectedProducts, { product }]);
  //   } else {
  //     setSelectedProducts([
  //       ...selectedProducts.filter(
  //         item => item.product?.articleNumber !== product?.articleNumber
  //       )
  //     ]);
  //   }
  // };
  return (
    <div className="upsell-list-item">
      <div className="image-and-information-combo-wrapper">
        <LinkEvaluator link={`${product?.primaryRoute?.path}`}>
          <div className={cx('item-image-wrapper')}>
            <Image
              src={product?.images?.[0]?.url}
              size={imageSizes}
              aspect={imageAspect}
            />
          </div>
        </LinkEvaluator>
        <div className="item-information-wrapper">
          <Paragraph text={itemHeader} weight={'bold'} />
          <Paragraph text={product?.name} />
          <PushPrice
            className="push-price"
            price={product?.price}
            previousPrice={product?.previousPrice}
          />
        </div>
      </div>
      <QuickBuyButton className="upsell-quickbuy" product={product} />
    </div>
  );
};
